import React, { useState, useRef, useEffect } from 'react';
import { generateAnswers, getFirstNumber, getAnswers, getAnimationValues } from './Subtracting.data';
import { 
    animationDurationToShowscoresPopup,
    animationDurationToMoveCorrectAnswer
} from "../../../config";
import { useParams } from 'react-router-dom';
import { updateStorage } from "../../../hooks/useStorage";
import { updateGameStorage } from "../../../hooks/useGameStorage";
import RightPart from '../../RightPart';
import LeftPart from './components/LeftPart';
import * as amplitude from '@amplitude/analytics-browser';
import { useUpdateReduxState } from "../../../hooks/useUpdateReduxState";
import { gameId } from "../../../hooks/getGameId";
import { calcGapY,getCoordinates } from './Subtracting.data';


export const Subtracting2 = ({state, handleOpenScore, count, handleUpdateProgress, answerSound, point, hint, subscription, onQuestionChange, handleTimerResult}) => {
    const {name, gameName} = useParams();
    const allAnswer = useRef(generateAnswers());
    const gameCount = useRef(0);
    const [result, setResult] = useState('?');
    const [answer, setAnswer] = useState(allAnswer.current[gameCount.current]);
    const [animation, setAnimation] = useState(getAnimationValues());
    const copyAnimation = [...animation];
    const firstNumber = useRef(getFirstNumber(answer));
    const secondNumber = useRef(firstNumber.current-answer);
    const answersArray = useRef(getAnswers(answer));
    const score = useRef(0);

    const updateState = useUpdateReduxState();

    useEffect(()=>{
        amplitude.track(`${"subtract"+"_"+gameName.replace("_", " ")+"_start"}`)
      }, []);

    const checkAnswer = (event, type, val) => {
        if (event==='mouseup') return;
        const answerForHistory = val ?? 'x';

        score.current += point*type;
        if (!subscription) {
          updateStorage(point*type);
        }

        if (val !== answer) {
          handleTimerResult(false)
          onQuestionChange?.(`${firstNumber.current}-${secondNumber.current}=${answerForHistory}`);
          return
        };   
        if(type){
          handleTimerResult(true);
          onQuestionChange?.(`${firstNumber.current}-${secondNumber.current}=${answerForHistory}`);
        }

        !type && setResult(val);
        setAnimation(copyAnimation);
        if (gameCount.current === count-1) {
            if (subscription) {
              updateState({
                userId: localStorage.getItem('user'),
                profileId: JSON.parse(localStorage.getItem('profile'))?._id,
                game: name,
                score: score.current,
                id: gameId(name, gameName),
                collection: name,
              })
            } else {
              handleUpdateProgress();
              updateGameStorage(name, gameName, point*type, true);
            }
            setTimeout(()=>handleOpenScore(), animationDurationToShowscoresPopup*1000);
            localStorage.setItem(`${name+'_'+gameName+'_'+'_score'}`, score.current);
          } else {
            if (!subscription) {
              handleUpdateProgress();
              updateGameStorage(name, gameName, point*type, false);
            }
            
            setTimeout(()=>{ 
              gameCount.current +=1
              const answer = allAnswer.current[gameCount.current];
              setAnswer(answer);
              setResult('?');
              setAnimation(getAnimationValues());
              firstNumber.current = getFirstNumber(answer);
              secondNumber.current = firstNumber.current-answer;
              answersArray.current = getAnswers(answer);
            }, animationDurationToMoveCorrectAnswer*1000);
          }
    }

    return (
        <div className="w-full h-full flex justify-between relative z-30">
            <LeftPart
               state={state}
               answer={answer}
               result={result}
               animation={animation}
               firstNumber={firstNumber.current}
               secondNumber={secondNumber.current}
            />
           <RightPart
               hint={hint}
               state={state}
               answer={answer}
               checkAnswer={checkAnswer}
               answerSound={answerSound}
               answers={answersArray.current}
               getCoordinates={getCoordinates}
               calcGapY={calcGapY}
            />
        </div>
    )
}